import * as LabelPrimitive from '@radix-ui/react-label'
import PropTypes from 'prop-types'
import * as React from 'react'

import { cn } from '@/utils/helpers'

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      'text-sm leading-none font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
      className,
    )}
    {...props}
  />
))
Label.displayName = LabelPrimitive.Root.displayName

Label.propTypes = {
  className: PropTypes.string,
}

export { Label }
